















import { Vue, Component, Prop } from 'vue-property-decorator'
import * as shareApi from '../api/shareApi'

@Component({})
export default class ShareMod extends Vue {
  @Prop() rangeDay
  @Prop() close: () => void
  async back() {
    // 【再测一次】的点击埋点
    await shareApi.getUpload('Click_ProgressMonitoringTest_Lexile')
    this.$router.push('/reimsAssess/needKnow?_hideShareButton=1')
  }
}
